import {
  SitemapElementsQuery,
  SitemapEntry,
  SitemapSection
} from '../../graphql/graphql';

interface FormattedSitemapElements {
  sitemapEntry: SitemapEntry[];
  sitemapSection: SitemapSection[];
}

export const getFormattedSitemapElements = (
  sitemapElements: SitemapElementsQuery['sitemapElements']
): FormattedSitemapElements =>
  (sitemapElements || []).reduce<FormattedSitemapElements>(
    (acc, curr) => {
      const typeName =
        curr.__typename === 'SitemapEntry' ? 'sitemapEntry' : 'sitemapSection';
      return { ...acc, [typeName]: [...acc[typeName], curr] };
    },
    { sitemapEntry: [], sitemapSection: [] }
  );
